import script from "./kaojiang_order.vue?vue&type=script&setup=true&lang=js"
export * from "./kaojiang_order.vue?vue&type=script&setup=true&lang=js"

import "./kaojiang_order.vue?vue&type=style&index=0&id=92a9a54c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92a9a54c"]])

export default __exports__